import { Skeleton } from 'components/ui/skeleton';
import { useMemo } from 'react';

/** Placeholder cards for a grouped list while its next page loads: `repeat` cards, each a grid of `amountOfColumns` blocks. */
const BoxLoader = ({
    amountOfColumns = 0,
    height = 40,
    repeat = 3,
}: {
    amountOfColumns: number;
    height: number;
    repeat?: number;
}) => {
    const content = useMemo(() => {
        const rows = [] as React.ReactNode[];
        const cells = [] as React.ReactNode[];
        for (let i = 0; i < amountOfColumns; i++) {
            // oxlint-disable-next-line react-doctor/no-array-index-as-key -- static skeleton placeholders never reorder
            cells.push(<Skeleton key={`cell-${i}`} className="w-full" style={{ height }} />);
        }

        for (let i = 0; i < repeat; i++) {
            rows.push(
                <div
                    className="border-divider bg-paper new:border-0 new:shadow-card new:outline-hidden grid gap-4 rounded-md border p-4 not-first:mt-4"
                    style={{ gridTemplateColumns: `repeat(${amountOfColumns}, 1fr)` }}
                    // oxlint-disable-next-line react-doctor/no-array-index-as-key -- static skeleton placeholders never reorder
                    key={`row-${i}`}
                >
                    {cells}
                </div>
            );
        }
        return rows;
    }, [amountOfColumns, height, repeat]);
    return <>{content}</>;
};

export default BoxLoader;
